<!-- 데스크톱 레이아웃 -->
<main class="hidden lg:flex flex-col gap-6 container mx-auto lg:pt-30 pb-15 px-4">
  @if (data(); as event) {
  <div class="flex flex-col lg:flex-row gap-6 w-full lg:items-start">
    <!-- 왼쪽: 이미지 + 탭 메뉴 + 컨텐츠 -->
    <div class="flex-2 flex flex-col gap-6 lg:max-h-[calc(100vh-240px)] lg:overflow-y-auto">
      <!-- 썸네일 이미지 -->
      <ng-container
        *ngTemplateOutlet="thumbnailTemplate; context: { $implicit: event, height: 'h-50 lg:h-100' }"></ng-container>

      <!-- 탭 메뉴 -->
      <div class="bg-white rounded-2xl lg:px-4">
        <app-segment [options]="segmentOptions" [(value)]="segment" />
      </div>

      <!-- 탭 컨텐츠 -->
      <ng-container
        *ngTemplateOutlet="tabContentTemplate; context: { $implicit: event, suffix: 'desktop' }"></ng-container>
    </div>

    <!-- 오른쪽: 고정 사이드바 -->
    <ng-container *ngTemplateOutlet="eventInfoSidebarTemplate; context: { $implicit: event }"></ng-container>
  </div>
  } @else {
  <app-not-found [isLoading]="loading()">
    <p>존재하지 않는 행사입니다.</p>
  </app-not-found>
  }
</main>

<!-- 모바일 레이아웃 -->
<app-page-modal-container class="lg:hidden">
  <main class="pb-20">
    @if (data(); as event) {
    <div class="flex flex-col gap-6 w-full">
      <!-- 썸네일 이미지 -->
      <ng-container *ngTemplateOutlet="thumbnailTemplate; context: { $implicit: event, height: 'h-60' }"></ng-container>

      <!-- 모바일 행사 정보 -->
      <div class="flex flex-col gap-6 bg-white rounded-2xl px-4">
        <ng-container *ngTemplateOutlet="eventInfoContentTemplate; context: { $implicit: event }"></ng-container>
      </div>

      <!-- 탭 메뉴 -->
      <div class="bg-white rounded-2xl">
        <app-segment [options]="segmentOptions" [(value)]="segment" />
      </div>

      <!-- 탭 컨텐츠 -->
      <ng-container
        *ngTemplateOutlet="tabContentTemplate; context: { $implicit: event, suffix: 'mobile' }"></ng-container>
    </div>
    } @else {
    <app-not-found [isLoading]="loading()">
      <p>존재하지 않는 행사입니다.</p>
    </app-not-found>
    }
  </main>

  <!-- 모바일 하단 고정 버튼 -->
  <div class="flex gap-3 px-4 py-2" footer>
    <ng-container *ngTemplateOutlet="actionButtonsTemplate"></ng-container>
  </div>
</app-page-modal-container>

<!-- 썸네일 이미지 템플릿 -->
<ng-template #thumbnailTemplate let-event let-height="height">
  @if (event.thumbnail) {
  <img
    [src]="event.thumbnail"
    [alt]="event.title"
    [class]="'w-full lg:rounded-2xl object-cover object-center shrink-0 ' + height" />
  } @else {
  <div [class]="'w-full bg-gray-100 lg:rounded-2xl flex flex-col items-center justify-center gap-3 shrink-0 ' + height">
    <app-icon name="mdi:image-off" size="lg" class="text-gray-400" />
    <span class="text-gray-500 font-medium">No Image</span>
  </div>
  }
</ng-template>

<!-- 탭 컨텐츠 템플릿 -->
<ng-template #tabContentTemplate let-event let-suffix="suffix">
  @if (segment() === 'details') {
  <div class="bg-white rounded-2xl px-4 pb-4">
    @if(event.details) {
    <div [innerHTML]="event.details | safeHtml" class="editor-content prose max-w-none"></div>
    } @else {
    <app-not-found>
      <p>등록된 정보가 없습니다.</p>
    </app-not-found>
    }
  </div>
  } @else if (segment() === 'venue') {
  <div class="bg-white rounded-2xl px-4 pb-4">
    <ng-container
      *ngTemplateOutlet="venueContentTemplate; context: { $implicit: event, suffix: suffix }"></ng-container>
  </div>
  } @else if (segment() === 'faq') {
  <div class="bg-white rounded-2xl px-4 pb-4">
    <app-faq />
  </div>
  } @else if (segment() === 'events') {
  <div class="bg-white rounded-2xl px-4 pb-4">
    @if(event.eventNotes) {
    <div [innerHTML]="event.eventNotes | safeHtml" class="editor-content prose max-w-none text-zinc-600"></div>
    } @else {
    <app-not-found>
      <p>등록된 정보가 없습니다.</p>
    </app-not-found>
    }
  </div>
  } @else if (segment() === 'notice') {
  <div class="bg-white rounded-2xl px-4 pb-4">
    @if(event.notice) {
    <div [innerHTML]="event.notice | safeHtml" class="editor-content prose max-w-none text-zinc-600"></div>
    } @else {
    <app-not-found>
      <p>등록된 정보가 없습니다.</p>
    </app-not-found>
    }
  </div>
  }
</ng-template>

<!-- 장소 정보 템플릿 -->
<ng-template #venueContentTemplate let-event let-suffix="suffix">
  <div class="space-y-6">
    <!-- 장소명 -->
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-2">
        <app-icon name="material-symbols:location-on-outline" class="size-5! text-primary-500" />
        <h3 class="text-lg font-semibold text-zinc-800">
          {{ event.place.name }}
        </h3>
      </div>
      <p class="text-zinc-600 ml-7">
        {{ event.place.address || '주소 정보가 없습니다.' }}
      </p>
    </div>

    <!-- 카카오맵 -->
    <div [id]="'kakao-map-container-' + suffix" class="kakao-map-target w-full h-50 rounded-xl"></div>

    <!-- 길찾기 버튼 -->
    <div class="flex gap-3 mt-4">
      <button
        (click)="openKakaoMapDirections()"
        class="cursor-pointer sb-aggro font-light flex-1 flex items-center justify-center gap-2 p-3 text-zinc-900 rounded-lg border border-zinc-200">
        길찾기
        <app-icon name="streamline:location-pin-3" class="size-5! text-zinc-400" />
      </button>
      <button
        (click)="openKakaoMapDetail()"
        class="cursor-pointer sb-aggro font-light flex-1 flex items-center justify-center gap-2 p-3 text-zinc-800 rounded-lg bg-zinc-100">
        상세안내
        <app-icon
          name="streamline:interface-arrows-bend-up-right-1-arrow-bend-curve-change-direction-right-to-up"
          class="size-4! text-zinc-400" />
      </button>
    </div>

    <div class="h-px bg-zinc-200"></div>

    <!-- 주차 정보 -->
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-2">
        <app-icon name="tabler:parking-circle" class="size-5! text-primary-500" />
        <h3 class="text-lg font-semibold text-zinc-800">주차 안내</h3>
      </div>
      @if (event.place.parkingInfo) {
      <div
        [innerHTML]="event.place.parkingInfo | safeHtml"
        class="editor-content prose max-w-none ml-7 text-zinc-600"></div>
      } @else {
      <app-not-found>
        <p>등록된 내용이 없습니다.</p>
      </app-not-found>
      }
    </div>

    <div class="h-px bg-zinc-200"></div>

    <!-- 찾아오는 길 -->
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-2">
        <app-icon name="material-symbols:directions-outline" class="size-5! text-primary-500" />
        <h3 class="text-lg font-semibold text-zinc-800">찾아오는 길</h3>
      </div>
      @if (event.place.directions) {
      <div
        [innerHTML]="event.place.directions | safeHtml"
        class="editor-content prose max-w-none ml-7 text-zinc-600"></div>
      } @else {
      <app-not-found>
        <p>등록된 내용이 없습니다.</p>
      </app-not-found>
      }
    </div>
  </div>
</ng-template>

<!-- 행사 정보 컨텐츠 템플릿 -->
<ng-template #eventInfoContentTemplate let-event>
  <h1 class="text-xl text-zinc-800">{{ event.title }}</h1>

  <!-- 행사 정보 그리드 -->
  <div class="space-y-4">
    <div class="flex gap-4">
      <span class="text-zinc-400 font-medium w-20 shrink-0">일자</span>
      <span class="text-zinc-800 font-medium">
        {{ formatDateRange(event.startAt, event.endAt) }}
      </span>
    </div>

    <div class="flex gap-4">
      <span class="text-zinc-400 font-medium w-20 shrink-0">장소</span>
      <div class="flex flex-col gap-1">
        @if (event.place.link) {
        <a
          [href]="event.place.link"
          target="_blank"
          class="text-primary-500 hover:underline flex items-center gap-2 font-medium">
          {{ event.place.name }}
          <app-icon name="mdi:open-in-new" class="size-4!" />
        </a>
        } @else {
        <span class="text-zinc-800 font-medium">{{ event.place.name || '-' }}</span>
        }
        <span class="text-zinc-500 text-sm">{{ event.place.address || '-' }}</span>
      </div>
    </div>

    <div class="flex gap-4">
      <span class="text-zinc-400 font-medium w-20 shrink-0">시간</span>
      <span class="text-zinc-800 font-medium">{{ formatTimeRange(event.startAt, event.endAt) }}</span>
    </div>
  </div>

  <div class="h-px border-t border-dashed border-zinc-200"></div>

  <!-- 입장료 -->
  <div class="flex flex-col gap-2">
    <div class="flex items-center gap-2">
      <span class="sb-aggro text-lg text-zinc-800"> {{ event.entranceFee.toLocaleString() }}원 </span>
      <span class="text-sm bg-primary-500/10 text-primary-500 px-2 py-1 rounded-md"> 사전등록 시 무료입장 </span>
    </div>
  </div>

  <!-- 무료입장 조건 -->
  <div class="flex flex-col gap-2 bg-zinc-50 p-4 rounded-lg">
    <span class="text-zinc-800 font-bold text-sm">무료입장</span>
    <ul class="list-disc list-inside text-zinc-400 text-sm space-y-1 px-2">
      <li>초청장소지자(초청카드 작성)</li>
      <li>사전등록자(홈페이지 온라인 사전 등록자)</li>
      <li>초등학생 이하 어린이(보호자 동반시)</li>
      <li>경로우대층 소지자</li>
      <li>국가유공자</li>
      <li>65세 이상</li>
    </ul>
  </div>
</ng-template>

<!-- 데스크톱 사이드바 템플릿 -->
<ng-template #eventInfoSidebarTemplate let-event>
  <div
    class="hidden lg:flex sticky top-24 flex-1 flex-col gap-6 bg-white rounded-2xl p-8 border border-zinc-200 self-start max-h-[calc(100vh-120px)] overflow-y-auto">
    <ng-container *ngTemplateOutlet="eventInfoContentTemplate; context: { $implicit: event }"></ng-container>

    <!-- 액션 버튼 -->
    <div class="flex lg:flex-col gap-2">
      <ng-container *ngTemplateOutlet="actionButtonsTemplate"></ng-container>
    </div>
  </div>
</ng-template>

<!-- 액션 버튼 템플릿 -->
<ng-template #actionButtonsTemplate>
  @if (isEventExpired()) {
  <!-- 행사 종료 안내 -->
  <div class="flex-1 bg-zinc-100 text-zinc-400 py-3 rounded-xl flex items-center justify-center gap-2 sb-aggro font-light">
    <app-icon name="material-symbols:event-busy-outline-rounded" class="size-5!" />
    행사가 종료되었습니다
  </div>
  } @else {
  <button
    [routerLink]="['/registration-form']"
    [queryParams]="{ eventId: data()?.id }"
    class="sb-aggro font-light cursor-pointer flex-1 bg-primary-500 text-white py-3 rounded-xl flex items-center justify-center gap-2">
    <app-icon name="material-symbols:arrow-outward-rounded" class="size-5!" />
    사전등록
  </button>
  <button
    [routerLink]="['/booth-application-form']"
    [queryParams]="{ eventId: data()?.id }"
    class="sb-aggro font-light cursor-pointer flex-1 bg-white border border-zinc-200 py-3 text-zinc-800 rounded-xl flex items-center justify-center gap-2">
    <app-icon name="mdi:file-document-edit-outline" class="size-5!" />
    참가 신청
  </button>
  }
</ng-template>
